/**
 * Parse `#RGB` / `#RRGGBB` (optional `#`) thành RGB 0–255.
 *
 * @returns `undefined` nếu chuỗi không hợp lệ.
 */
export function parseCssHexToRgb(
  input: string | null | undefined,
): [number, number, number] | undefined {
  if (input == null || typeof input !== 'string') return undefined;
  const s = input.trim();
  const m = /^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.exec(s);
  if (!m) return undefined;
  const hex = m[1];
  if (hex.length === 3) {
    const r = parseInt(hex[0] + hex[0], 16);
    const g = parseInt(hex[1] + hex[1], 16);
    const b = parseInt(hex[2] + hex[2], 16);
    return [r, g, b];
  }
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  if ([r, g, b].some((n) => Number.isNaN(n))) return undefined;
  return [r, g, b];
}
